import "./ellipsis.css";
import { Ellipsis } from './ellipsis';
export default Ellipsis;